import * as React from "react";
import { useTheme } from '@material-ui/core/styles';
import { InputAdornment, TextField } from "@material-ui/core";
import { defaultInputProps, useRootStyles } from "./globalprops"
import { Loading } from "./Loading";
import { ICommonControlWithMinMaxWithLabel } from "./ICommonInputsControls";
import { useTranslation } from 'react-i18next';

// All the incoming values
interface IProps {
    
}

// Outgoing functions
interface IDispatch {

}

// Actual Component
export type AllProps = IProps & IDispatch & ICommonControlWithMinMaxWithLabel<number>;
export const NumberInput = (props: AllProps) => {
    const classes = useRootStyles(useTheme());
    const { t } = useTranslation('common');
    
    const label = props.label || "";
    const [value, setValue] = React.useState(props.value === undefined ? null : props.value);

    const calculateError = (newValue: number | null): [boolean, string] => {
        if (props.error) {
            return props.error;
        }

        if (!newValue && props.required) {
            return [true, t('xIsRequired', {x: label})]; 
        }
        
        const betterNewValue = newValue || 0;
        if ((props.minValue !== undefined && betterNewValue < props.minValue) || (props.maxValue !== undefined && betterNewValue > props.maxValue)) {
            if (props.minValue === undefined) {
                return [true, t('xMustBeLessThanY', {x: label, y: props.maxValue})];
            }
            if (props.maxValue === undefined) {
                return [true, t('xMustBeGreaterThanY', {x: label, y: props.minValue})];
            }
            return [true, t('xMustBeBetweenYAndZ', {x: label, y: props.minValue, z: props.maxValue})];
        }

        if (props.onValidate) {
            const [isError, errorMessage] = props.onValidate(betterNewValue);
            if (isError) {
                return [true, errorMessage];
            }
        }

        return [false, ""];
    }

    const [error, setError] = React.useState<[boolean, string]>(props.error || [false, ""]);


    const doChange = (newValue: number | null) => {
        const error = calculateError(newValue);
        setError(error);
        setValue(newValue);
        props.onChange && props.onChange(newValue, error[0] === false); // Return null if in an error state
    }

    React.useEffect(() => {
        props.prevalidate && doChange(value);
    }, []);

    React.useEffect(() => {
        setValue(props.value === undefined ? null : props.value);
    }, [props.value, props.error]);

    return (props.loading ? <Loading label={props.label} /> : <TextField
            {...defaultInputProps}
            className={classes.root}
            label={label}
            placeholder={props.placeholder || (props.minValue ? props.minValue.toString() : "0")}
            disabled={props.disabled || props.loading}
            type="number"
            value={value}
            onChange={(e) => {
                const v = parseInt(e.target.value);
                doChange(v);
            }}
            error = {error[0]}
            helperText = { error[0] ? error[1] : undefined }
            required={props.required}
            InputProps={{
                startAdornment : props.icon && <InputAdornment position="start">{props.icon}</InputAdornment>
            }}
        />)
}